var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 884,
    height: 1242,
    viewBox: "0 0 884 1242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 884,
    height: 1242,
    transform: "translate(-0.129 0.34)",
    fill: "#005aa7"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.129 -0.34)",
    opacity: 0.056
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,261,357.9,615.95,0,981.344l252.639,261L621.069,876.946l263.165-261L621.069,365.394,252.639,0Z",
    transform: "translate(0 0)",
    fill: "#005aa7"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLarge);
export default __webpack_public_path__ + "static/media/chevron-large.f2aa21f6254ffd6311eac998d48a13ed.svg";
export { ForwardRef as ReactComponent };